import React, { useState } from "react";
import LogoLight from "../../asset/logo_light.png";
import "./LoginAndSignup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const translations = {
  english: {
    recovery: "Set new password",
    forgetPassword: "Have you forgotten your password?",
    loginError: "Login failed",
    notRegistered: "Not Registered? Go to signup page",
    password: "Password",
    rpassword: "Confirm Password",
    email: "Email Address",
    login: "Login",
    alreadyRegistered: "Go to login page",
  },
  german: {
    recovery: "Neues Passwort festlegen",
    forgetPassword: "Haben Sie Ihr Passwort vergessen?",
    loginError: "Login ist fehlgeschlagen",
    notRegistered: "Nicht registriert? Zur Anmeldeseite gehen",
    password: "Passwort",
    rpassword: "Passwort bestätigen",
    email: "E-Mail Adresse",
    login: "Login",
    alreadyRegistered: "Bereits registriert? Gehen Sie zur Login-Seite.",
  },
  italian: {
    recovery: "Imposta una nuova password",
    forgetPassword: "Hai dimenticato la password?",
    loginError: "Accesso non riuscito",
    notRegistered: "Non sei registrato? Vai alla pagina di registrazione",
    password: "Password",
    rpassword: "Conferma Password",
    email: "Indirizzo Email",
    login: "Accedi",
    alreadyRegistered: "Già registrato? Vai alla pagina di accesso.",
  },
  czech: {
    recovery: "Nastavte nové heslo",
    forgetPassword: "Zapomněli jste heslo?",
    loginError: "Přihlášení se nezdařilo",
    notRegistered: "Nejste registrováni? Přejděte na registrační stránku",
    password: "Heslo",
    rpassword: "Potvrďte heslo",
    email: "Emailová Adresa",
    login: "Přihlásit se",
    alreadyRegistered: "Již registrováni? Přejděte na přihlašovací stránku.",
  },
};
const config = require("../../config.js");
function RecoveryPasswordTokenPage() {
  const { token } = useParams();
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [currentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );
  const lang = translations[currentLanguage];

  const clearInput1 = () => setPassword1("");
  const clearInput2 = () => setPassword2("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(
        config.env.API_BASE_URL + "/api/auth/recovery-password/" + token,
        {
          password: password1,
        }
      );

      navigate("/");
    } catch (error) {
      console.log(error);
      setError(error.response ? error.response.data.message : lang.loginError);
    }
  };

  const GotoSignupPage = () => {
    navigate("/signup");
  };

  return (
    <div className="loginandsignup-main">
      <div className="d-flex justify-content-center align-items-center flex-column gap-4">
        <img src={LogoLight} alt="logo" width={300} />
        <section className="loginandsignup">
          <form onSubmit={handleSubmit}>
            {error && <p className="error-message">{error}</p>}
            <div className={`input-wrap ${password1 ? "has-value" : ""}`}>
              <input
                type="password"
                className="login-input2"
                value={password1}
                onChange={(e) => setPassword1(e.target.value)}
              />
              <label>{lang.password}</label>
              {password1 && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput1}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className={`input-wrap ${password2 ? "has-value" : ""}`}>
              <input
                type="password"
                className="login-input2"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
              <label>{lang.rpassword}</label>
              {password2 && (
                <button
                  type="button"
                  className="clear-button"
                  onClick={clearInput2}
                >
                  <FontAwesomeIcon
                    className="input-close-icon"
                    icon={faCircleXmark}
                  />
                </button>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button type="submit" className="btn-signup" disabled={password1 != password2 || password1 == ""}>
                {lang.recovery}
              </button>
            </div>
            <p
              className="fw-light"
              style={{ cursor: "pointer" }}
              onClick={GotoSignupPage}
            >
              {lang.alreadyRegistered}
            </p>
          </form>
        </section>
      </div>
    </div>
  );
}

export default RecoveryPasswordTokenPage;
